import React from 'react';
import { Button, Card, CardContent, Fab, Grid, ListItemIcon, ListItemText, MenuItem, Modal, Stack, TextField, Tooltip } from '@mui/material';
import config from 'src/config';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import showLoading from 'src/common/loading';
import '@mdxeditor/editor/style.css'
import { MDXEditor, UndoRedo, BoldItalicUnderlineToggles, toolbarPlugin, headingsPlugin, listsPlugin, quotePlugin, thematicBreakPlugin, CreateLink, InsertTable, ListsToggle, CodeToggle, BlockTypeSelect, linkPlugin, tablePlugin, imagePlugin, codeBlockPlugin, linkDialogPlugin } from '@mdxeditor/editor'
import { addFile, getFile, updateFile } from 'src/services/file.service';
import ModeIcon from '@mui/icons-material/Mode';

// ----------------------------------------------------------------------



class AddEditNoteModal extends React.Component {

	constructor(props) {
		super(props);

		this.state = {

			role: localStorage.getItem('role') || config.USER_ROLES.USER,
			mode: this.props.file ? 'edit' : 'add',
			add_view_type: this.props.add_view_type || 'fab',
			is_modal_open: this.props.open || false,

			file: null,
			name: '',
			note: '',

		}
	}

	// promised setState
	setStateAsync(state) {
		return new Promise((resolve) => {
			this.setState(state, resolve)
		});
	}

	async componentDidMount() {
		if (this.props.file) {
			this.fetchFile();
		}
	}

	async componentDidUpdate(prevProps) {
		if (this.props.file && this.props.file !== prevProps.file) {
			this.fetchFile();
		}
	}

	async fetchFile() {

		const file = await getFile(this.props.file._id);
		if (!file) {
			return;
		}
		if (file.error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: file.error,
				confirmButtonText: 'Ok',
				confirmButtonColor: config.primaryColor
			});
			return;
		}

		await this.setState({
			file: file.file,
			name: file?.file?.name ?? '',
			note: file?.file?.note ?? '',
			mode: 'edit',
			is_modal_open: true
		});

	}
		

	isFormValid() {
		if (!this.state.name || this.state.name.trim() === '') {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Name is required'
			});
			return false;
		}
		return true;
	}

	async addNote() {

		if (!this.isFormValid())
			return;

		showLoading(true);
		let addNoteRes = await addFile({
			type: 'note',
			name: this.state.name,
			note: this.state.note
		});
		if (addNoteRes.error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: addNoteRes.error
			});
		} else {
			Swal.fire({
				icon: 'success',
				title: 'Success',
				text: 'Note created successfully'
			});
			this.setState({
				is_modal_open: false,
				file: null,
				name: '',
				note: ''
			});
			if (this.props.onClose)
				this.props.onClose();
			if (this.props.onCreate)
				this.props.onCreate();
			if (this.props.onReload)
				this.props.onReload();
		}
	}

	async editNote() {
		if (!this.isFormValid())
			return;

		showLoading(true);
		let editNoteRes = await updateFile(this.props.file._id, {
			name: this.state.name,
			note: this.state.note
		});
		if (editNoteRes.error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: editNoteRes.error
			});
		} else {
			Swal.fire({
				icon: 'success',
				title: 'Success',
				text: 'Note updated successfully'
			});
			this.setState({
				file: null,
				name: '',
				note: '',
				is_modal_open: false
			});
			if (this.props.onClose)
				this.props.onClose();
		}
	}

	async saveNote() {
		if (this.state.file) {
			await this.editNote();
		} else {
			await this.addNote();
		}
		if (this?.props?.onReload) {
			await this.props.onReload();
		}
	}

	render() {
		return (
			<>
			{(!this.props.hideAddButton) ? (
				// ((this.props?.add_view_type === 'fab') && (
				// 	<Tooltip title="Add Note" placement="top">
				// 		<Fab size="small" color="secondary" aria-label="add"
				// 			onClick={() => {
				// 				this.setState({
				// 					is_modal_open: true,
				// 					mode: 'add',
				// 					file: null,
				// 					name: '',
				// 					note: ''
				// 				});
				// 			}}
				// 		>
				// 			<ModeIcon />
				// 		</Fab>
				// 	</Tooltip>
				// ))
				
				((this.props?.add_view_type === 'menu_item') ? (
					<MenuItem
						onClick={() => {
							this.setState({
								is_modal_open: true,
								mode: 'add',
								file: null,
								name: '',
								note: ''
							});
						}}
					>
						<ListItemIcon>
							<ModeIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>Create Note</ListItemText>
					</MenuItem>
				) : null)
			) : null}
			<Modal
				open={this.state.is_modal_open}
				onClose={() => {
					this.setState({
						is_modal_open: false,
						file: null,
						name: '',
						note: ''
					});
					if (this.props.onClose)
						this.props.onClose();
				}}
			>
				<Grid container>
					<Grid item style={modalStyle} xs={12} md={8} lg={6}>
						<Card variant='outlined'>
							<CardContent style={{ padding: 20 }}>
								<Stack direction="column" spacing={2}>
									<TextField
										size='small'
										label={'Name'}
										variant="outlined"
										fullWidth
										value={this.state.name}
										onChange={(e) => {
											this.setState({
												name: e.target.value
											});
										}}
									/>

									<MDXEditor
										key={this.state.file?._id ?? 'new'}
										markdown={this.state.note ?? ''}
										onChange={(value) => {
											this.setState({
												note: value
											});
										}}
										// plugins={[headingsPlugin(), listsPlugin(), quotePlugin(), thematicBreakPlugin()]}
										plugins={[
											toolbarPlugin({
												toolbarClassName: 'my-classname',
												toolbarContents: () => (
													<>
														<UndoRedo />
														<BlockTypeSelect />
														<BoldItalicUnderlineToggles />
														<InsertTable />
														<CreateLink />
														<ListsToggle />
														<CodeToggle />
													</>
												)
											}),
											headingsPlugin(), listsPlugin(), quotePlugin(), thematicBreakPlugin(), linkPlugin(), tablePlugin(), imagePlugin(), codeBlockPlugin(), linkDialogPlugin()
										]}
									/>
									
									<Button
										variant='contained'
										fullWidth
										color='primary'
										onClick={async () => {
											this.saveNote();
										}}
									>
										Save
									</Button>
								</Stack>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Modal>
			</>
		);
	}
}

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '100%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 2,
	maxHeight: '90%',
	overflowY: 'auto'
};

export default function (props) {
	const navigate = useNavigate();

	return <AddEditNoteModal {...props} navigate={navigate} />;
}
